import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 10
            }
        }
    }, palette: {
        primary: {
            main: "#3a3f53"
        },
        secondary: {
            main: "#ff6600"
        }
    }
});